// Preview of an uploaded page (pre-landing, offer) in a frame, with a button
// that opens it in a new tab. item = {name, url} or null (closed). Uploaded
// pages live on the API host, so a relative url is resolved against it.
import React from 'react';
import { API } from '../App';
import { useT } from '../i18n';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { ExternalLink } from 'lucide-react';

export function bundleUrl(u) {
  return u && u.charAt(0) === '/' ? API.slice(0, API.lastIndexOf('/api')) + u : u;
}

export function openBundle(u) {
  if (u) window.open(bundleUrl(u), '_blank', 'noopener,noreferrer');
}

export default function BundlePreview({ item, onClose, openLabel }) {
  const { t } = useT();
  const label = openLabel || t('Preview');
  return (
    <Dialog open={!!item} onOpenChange={(open) => { if (!open && onClose) onClose(); }}>
      <DialogContent className="max-w-5xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>{item?.name || t('Preview')}</DialogTitle>
          <DialogDescription className="flex items-center gap-2">
            <span className="truncate">{item?.url}</span>
            <Button variant="ghost" size="sm" className="h-6 w-6 p-0" aria-label={label} title={label} onClick={() => openBundle(item?.url)}>
              <ExternalLink className="w-3 h-3" />
            </Button>
          </DialogDescription>
        </DialogHeader>
        {item?.url && (
          <div className="rounded-lg border overflow-hidden" style={{ height: '70vh' }}>
            <iframe
              src={bundleUrl(item.url)}
              title={item.name || t('Preview')}
              className="w-full h-full"
              sandbox="allow-scripts allow-same-origin"
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
